<template>
  <div class="LKBannersItem">
    <div class="LKBannersItem__content">
      <img
        v-if="data.image_url"
        :src="data.image_url"
        loading="lazy"
        alt=""
        class="LKBannersItem__img"
      >
      <BCollapser
        :min-height="60"
        show-title="Читать полностью"
        btn-class="LKBannersItem__btn-more"
      >
        <div
          class="LKBannersItem__body"
          v-html="data.body"
        />
      </BCollapser>
    </div>

    <div v-if="data.btn_title" class="LKBannersItem__button-box">
      <router-link v-if="to" :to="to" class="LKBannersItem__button w-inline-block">
        <div class="text-md-bold mod-allert" v-text="data.btn_title" />
      </router-link>

      <a v-else :href="data.btn_link" class="LKBannersItem__button w-inline-block">
        <div class="text-md-bold mod-allert" v-text="data.btn_title" />
      </a>
    </div>
  </div>
</template>

<script>
import BCollapser from '@/components/common/BCollapser.vue'

export default {
  name: 'LKBannersItem',
  components: {
    BCollapser,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    to() {
      const link = this.data.btn_link
      const { href } = this.$router.resolve(link)
      return href === link ? href : null
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-height.scss"></style>

<style lang="scss">
.LKBannersItem {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-height: 120px;
  padding: 16px;
  background-color: $webflow-color-blue-light;
  border-radius: 2px;

  & &__body p {
    font-weight: normal;
  }

  &__close {
    position: absolute;
    top: 15px;
    right: 15px;
    bottom: auto;
    left: auto;
    transition: transform $webflow-transition;
    transform: rotate(0deg);

    &:hover {
      transform: rotate(90deg);
    }
  }

  &__img {
    width: 85px;
    min-width: 85px;
    height: 85px;
    min-height: 85px;
    margin-right: 20px;

    @media screen and (max-width: 991px) {
      width: 60px;
      min-width: 60px;
      height: 60px;
      min-height: 60px;
      margin-right: 0;
      margin-bottom: 15px;
    }
  }

  &__button-box {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 20px;
    margin-left: 20px;
    border-left: 1px solid $webflow-color-alert-line;

    @media screen and (max-width: 767px) {
      width: 100%;
      height: auto;
      padding-top: 20px;
      padding-left: 0;
      margin-top: 20px;
      margin-left: 0;
      border-top: 1px solid $webflow-color-alert-line;
      border-left-style: none;
      border-left-width: 0;
    }

    @media screen and (max-width: 479px) {
      justify-content: center;
      width: 100%;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    padding: 15px 60px;
    background-color: $webflow-color-blue-dark;
    border-radius: 100px;
    transition: background-color $webflow-transition;
    text-decoration-line: none;

    @media screen and (max-width: 767px) {
      padding: 10px 30px;
    }

    &:hover {
      background-color: $webflow-color-blue-dark-hover;
    }
  }

  &__close-img {
    width: 16px;
    min-width: 16px;
    max-width: none;
    height: 16px;
    min-height: 16px;
  }

  &__content {
    display: flex;
    align-items: flex-start;

    @media screen and (max-width: 991px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__btn-more {
    padding: 0 !important;
    font-weight: bold;
    color: $webflow-color-blue-dark !important;
    text-decoration: dotted;
    border: none;
    border-bottom: 1px solid $webflow-color-blue;
    border-radius: 0;
  }
}
</style>
